import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../../redux/store'
import {useGetUserListQuery} from '../../../../../../redux/api/services/user'
import {CustomTable} from '../../../../../../helpers/elements/custom/CustomTable/CustomTable'
import CustomPagination from '../../../../../../helpers/elements/custom/CustomPagination'
import {setUserFilter} from '../../../../../../redux/slices/userFilterSlice'
import {ListLoading} from '../../../../../../helpers/elements/table/loading/ListLoading'
import {userColumns} from './columns/_columns'

export const UserTable = () => {
  const infoState = useSelector((state: RootState) => state.info)
  const currentUserFilter = useSelector((state: RootState) => state.userFilterSlice)
  const {
    data: listUser,
    isError,
    error,
    isLoading,
  } = useGetUserListQuery({
    info: infoState,
    requestContent: {
      page: currentUserFilter.page,
      pageSize: currentUserFilter.pageSize,
      filters: {
        search: currentUserFilter.search,
      },
    },
  })

  const dispatch = useDispatch()

  return (
    <>
      {/* <GenericError isError={isError} error={getRTKError(error)} /> */}
      {listUser?.responseContent && listUser?.responseContent.userList.length > 0 ? (
        <>
          <CustomTable data={listUser?.responseContent.userList} columns={userColumns} />
          <CustomPagination
            pagination={listUser.responseContent.pageProperties}
            isLoading={false}
            onChange={(page) => {
              dispatch(
                setUserFilter({
                  ...currentUserFilter,
                  page: page,
                })
              )
            }}
          />
        </>
      ) : (
        <div className='d-flex flex-column text-center pt-10 pb-20'>
          <span className='fw-semibold text-primary-dark fs-2qx'>
            No se encontraron resultados para tu búsqueda
          </span>
          <div className='text-primary-dark fs-4 w-50 mx-auto'>
            Verifica los filtros o crea un nuevo usuario.
          </div>
        </div>
      )}

      {isLoading && <ListLoading />}
    </>
  )
}
